import React from 'react';
import {KeyboardDatePicker as MUIDatePicker} from '@material-ui/pickers';
import {IconButton} from '@material-ui/core';

import styles from './DatePicker.scss';
import TextField from './TextField';
import CloseIcon from '../icons/CloseIcon';

export default function DatePicker(props) {
    const handleClear = (e) => {
        e.stopPropagation();
        props.onChange(null);
    }

    return (
        <MUIDatePicker
            TextFieldComponent={TextField}
            error={Boolean(props.error)}
            autoOk
            invalidDateMessage={null}
            invalidLabel={null}
            minDateMessage={null}
            maxDateMessage={null}
            InputProps={{
                endAdornment: props.value && (
                    <IconButton
                        onClick={handleClear}
                    >
                        <CloseIcon />
                    </IconButton>
                )
            }}
            className={styles.input}
            {...props}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/fields/DatePicker.jsx